import mapData from "lib/stores/mapData";
import { getProductPoints, getBoundingBox, fitBounds, updateDeckLayers } from "lib/map/functions";

export default function onUpdateProductsCountry(deckRef, setLayers) {
  if (!mapData.productsCountry || (mapData.productsCountry && !mapData.selectedProduct)) {
    try {
      document.querySelector(".mapboxgl-map").style.opacity = "1.0";
    } catch (error) {}
    return;
  }
  if (!mapData.selectedProduct || !mapData.productsCountry) return;
  try {
    const points = getProductPoints();
    const bounds = getBoundingBox(points);
    const fittedBounds = fitBounds(bounds, deckRef.current.deck.width, deckRef.current.deck.height);
    mapData.viewState = {
      ...mapData.viewState,
      ...fittedBounds,
      pitch: 40,
      bearing: 0
    };
  } catch (error) {
  }

  updateDeckLayers(setLayers, mapData.viewState);
  try {
    if (mapData.selectedProduct) {
      document.querySelector(".mapboxgl-map").style.opacity = "0.0";
    }
  } catch (error) {
  }
}
